<template v-if="entitiesLoaded">
    <div style="height: 100%; min-height: 100%;" class="wrap" :style="{'overflow-y':chat_overflow}">
        <div id="js-chat-user-cmp" class="messages-box"
            :style="{'padding-bottom': (textarea.height + 30 * 2) > 108 ? (textarea.height + 30 * 2 + (replyExists ? 60 : 0))+'px' :
             (replyExists ? '168px' : '108px')}"
            @click="hideAttachMenu">
            <slot></slot>

            <svg class="svg" width="0" height="0">
              <clipPath id="media-clip-incomming" clipPathUnits="objectBoundingBox">
                    <path d="M0.113,0 C0.113,0,0.113,0,0.113,0 H0.068 H0.055 H0.01 C0.004,0,0,0.005,0,0.01 C0,0.012,0.001,0.014,0.002,0.016 L0.046,0.084 V0.952 C0.046,0.979,0.066,1,0.092,1 H0.954 C0.979,1,1,0.979,1,0.952 V0.048 C1,0.021,0.979,0,0.954,0 H0.113"></path>
                </clipPath>
            </svg>
            <svg class="svg" width="0" height="0">
                <clipPath id="media-clip-outcomming" clipPathUnits="objectBoundingBox">
                    <path d="M0.887,1 h0.103 a0.01,0.01,0,0,0,0.01,-0.01 c0,-0.002,-0.001,-0.004,-0.002,-0.006 L0.954,0.916 V0.048 c0,-0.027,-0.021,-0.048,-0.046,-0.048 H0.046 C0.021,0,0,0.021,0,0.048 v0.904 c0,0.027,0.021,0.048,0.046,0.048 h0.841"></path>
                </clipPath>
            </svg>

            <infinite-loading
                ref="infiniteLoadingChat"
                @infinite="getMessages"
                spinner="bubbles"
                direction="top">
                <span slot="no-results">{{ trans('no_chat_messages') }}</span>
                <span slot="no-more" v-if="false">{{ trans('no_more_chat_messages') }}</span>
            </infinite-loading>

            <div class="fixed-event-box" v-if="chatMode === 'event' && isMyEvent(event)" @click="openEvent(eventId, 'event')">
                <div class="img" :style="{'background': `url(${event.photo_small}) no-repeat center / cover`}"></div>
                <div class="col">
                    <div class="event-title">{{ event.title }}</div>
                    <div class="date">{{ event.event_date | formatDate('day-date-short') }}</div>
                </div>
            </div>

            <div v-for="(msg, index) in messages"
                 @touchstart="startTouch(msg,index,$event)"
                 @touchend="endTouch(msg,index,$event)"
                 @touchmove="touchMove(msg,index,$event)"
                 @click="messageClicked(msg,index,$event)" class="message-box"
                 :class="{'selected' : msg.id === selected_message}"
                 :id="`msg-${msg.id}`">
                <div v-if="isNewDay(index)" class="timeline">{{ msg.idate | formatDate('day-date')}}</div>
                <div v-if="msg.cancelled" class="message removed" v-bind:class="{'outcomming': msg.user_to === user.id, 'incomming': msg.user_to !== user.id}">
                  {{ trans('removed') }}

                  <svg width="33" height="25" fill="none" class="svg-appendix outcomming" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#a)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#99F475" d="M0 0h33v25H0z"/>
                      </clipPath>
                    </defs>
                  </svg>

                  <svg width="33" height="25" fill="none" class="svg-appendix incomming" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#a)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#242529" d="M0 0h33v25H0z"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div v-else-if="(msg.msg_type === 'image') && msg.image_id === null && !msg.cancelled" class="message photo removed" v-bind:class="{'outcomming': msg.user_to == userId, 'incomming': msg.user_to != userId}">
                  <span></span>
                </div>
                <div v-else-if="(msg.msg_type === 'video') && msg.video_id === null && !msg.cancelled" class="message video removed" v-bind:class="{'outcomming': msg.user_to == userId, 'incomming': msg.user_to != userId}">
                  <span></span>
                </div>
                <div v-else-if="!msg.cancelled" class="message trigger-touch" 
                     :class="{'last': isMessageLast(index) || !!msg.failed,
                        'outcomming': msg.user_to === user.id,
                        'incomming': msg.user_to !== user.id,
                        'msg location': msg.msg_type === 'location',
                        'msg photo': msg.msg_type === 'image',
                        'msg video': msg.msg_type === 'video',
                        'has-reply' : msg.reply_message,
                        'press' : message_started_touch_animation === msg.id
                    }">
<!--                  <div class="close" @click="tryDelete(msg.id)" v-bind:class="{'no-pro': !userIsPro}" v-if="msg.user_to == userId"></div>-->


                  <svg v-if="msg.user_from !== currentUser.id && msg.reply_message && (msg.msg_type === 'image' || msg.msg_type === 'video')" width="33" height="25" fill="none" class="svg-appendix incomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#a)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#242529" d="M0 0h33v25H0z"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <div v-if="msg.reply_message" @click="findAndscrollToMessage(msg.reply_message.id)" class="reply-on-container trigger-touch">
                    <div class="reply-on-container_title trigger-touch">
                      <span class="reply-on-container_title-headline trigger-touch">{{msg.reply_message.user.headline}}</span>
                      <span class="reply-on-container_title-handle trigger-touch">@{{msg.reply_message.user.handle}}</span>
                    </div>
                    <div class="reply-on-container_message trigger-touch">
                      <div class="trigger-touch" v-if="msg.reply_message.msg_type === 'text'">{{msg.reply_message.message}}</div>
                      <div class="trigger-touch reply-on-container_message-photo" v-else-if="msg.reply_message.msg_type === 'image'" :style="{'background-image': 'url(' + getImagePath(msg.reply_message) + ')' }"></div>
                      <div class="trigger-touch reply-on-container_message-video" v-else-if="msg.reply_message.msg_type === 'video'" :style="{'background': 'url(' + (msg.reply_message.thumbnail_gif || msg.reply_message.thumbnail_img) + ') center / cover' }"></div>
                      <div class="trigger-touch reply-on-container_message-location" v-else-if="msg.reply_message.msg_type === 'location'" :style="{'background-image': 'url(/main/img/icons/message-location-' + (msg.reply_message.user_from === currentUser.id ? 'outcomming' : 'incomming') + '.svg?ver=2)' }"></div>
                    </div>
                  </div>
                  <div class="context-menu-icon" :class="{'hide' : msg.id === selected_message}" @click="showContextMenu(msg,index)">
                    <span class="arrow-circle"></span>
                  </div>
                  <div class="message-text trigger-touch"  v-if="msg.msg_type === 'text'" style="word-break: break-word;" @click="messageClick($event,msg)">
                    <div v-html="msgText || '&nbsp;'" v-for="msgText in getMsgTextWithLinks(msg.message,msg.links).split('\n')" class="notranslate trigger-touch">
                    </div>
                    <svg width="33" height="25" fill="none" class="trigger-touch svg-appendix outcomming" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#a)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                      </g>
                      <defs>
                        <clipPath id="a">
                          <path fill="#99F475" d="M0 0h33v25H0z"/>
                        </clipPath>
                      </defs>
                    </svg>

                    <svg width="33" height="25" fill="none" class="trigger-touch svg-appendix incomming" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#a)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                      </g>
                      <defs>
                        <clipPath id="a">
                          <path fill="#242529" d="M0 0h33v25H0z"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div class="message-photo trigger-touch" v-if="msg.msg_type === 'image'"  @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewPhoto(msg)">
                    <div :class="{'save-available' : selected_message === msg.id && !touchstarted}" class="img" :style="{'background-image': 'url(' + getImagePath(msg) + ')' }"></div>
                  </div>

                  <div class="message-video  trigger-touch"   v-if="msg.msg_type === 'video'" @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewVideo(msg)">
                    <div :class="{'save-available' : selected_message === msg.id && !touchstarted}" class="img"  :style="{'background': 'url(' + (msg.thumbnail_gif || msg.thumbnail_img) + ') center / cover' }"></div>
                  </div>

                  <div class="message-location  trigger-touch" v-if="msg.msg_type === 'location'" @click.stop="msg.failed ? editMessageForNotDelivered(msg) : viewLocation(msg)">
                    <svg width="33" height="25" fill="none" class="svg-appendix outcomming" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#a)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.79 1.12 1.25 21.02A2.56 2.56 0 0 0 3.38 25h27.05a2.56 2.56 0 0 0 2.13-3.98L19.03 1.12a2.56 2.56 0 0 0-4.24 0Z" fill="#99F475"/>
                      </g>
                      <defs>
                        <clipPath id="a">
                          <path fill="#99F475" d="M0 0h33v25H0z"/>
                        </clipPath>
                      </defs>
                    </svg>

                    <svg width="33" height="25" fill="none" class="svg-appendix incomming" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#a)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                      </g>
                      <defs>
                        <clipPath id="a">
                          <path fill="#242529" d="M0 0h33v25H0z"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <div class="message-not-delivered" v-if="msg.failed"></div>
                  <div v-if="msg.failed" class="message-not-delivered-text" @click.stop="editMessageForNotDelivered(msg)">
                    {{ trans('message_not_delivered') }}
                  </div>
                  <div v-if="!msg.failed && isMessageLast(index)" class="time">
                        <span v-if="msg.user_to == user.id && userIsPro" v-bind:class="{'is-read': msg.is_read === 'yes'}">
                            <span class="message-info delivered" v-if="msg.is_read !== 'yes'"></span>
                            <span class="message-info read" v-else></span>
                        </span>
                    {{ msg.idate | formatDate('hour',currentUser.unit_system) }}
                  </div>

                  <div v-if="msg.emojies && msg.emojies.length" class="emojies">
                    <div v-for="emoji in msg.emojies" v-html="emoji.emoji_code" @click="deleteEmoji(emoji,msg,index)" :class="{'my':emoji.user_id === currentUser.id}" class="emoji-item">

                    </div>
                  </div>
                </div>
            </div>
            <div v-if="typingEnabled(userId,eventId)" class="message-box">
              <div class="message typing incomming">
                <div class="dot-flashing"></div>
                <svg width="33" height="25" fill="none" class="svg-appendix incomming trigger-touch" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#a)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="m18.21 23.88 13.54-19.9A2.56 2.56 0 0 0 29.62 0H2.57A2.56 2.56 0 0 0 .44 3.98l13.53 19.9a2.56 2.56 0 0 0 4.24 0Z" fill="#242529"/>
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#242529" d="M0 0h33v25H0z"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
        </div>
        <ContextMenu @delete="tryDelete" @copyCallback="copyCallback" @focus="focusMessageField" :chatMode="chatMode" :eventId="eventId" :userId="userId"  @hideContextMenu="hideContextMenu" ref="contextMenu" ></ContextMenu>
        <EmojiComponent ref="emojiModal" ></EmojiComponent>
        <MessageCopiedComponent :isShown="message_copied" :type="message_copied_type"></MessageCopiedComponent>
        <transition name="fade" >
          <div v-show="showScrollBottom && !search_handle" class="scroll_bottom-button"
               :class="{'reply-shown': replyExists,'attach-menu-open': attachMenuVisible, 'send-media-open': tab === 'photo' || tab === 'video', 'photo': tab === 'photo', 'video': tab === 'video', 'send-location-open': tab === 'location'}"
               style="margin-bottom: 10px;"
               @click="scrollToBottom()" :title="trans('arrow_scroll_top')">
            <svg class="icon icon-arrow_down"><use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_down')"></use></svg>
          </div>
        </transition>
        
        <div  class="footer" :class="{'reply-shown': replyExists,'attach-menu-open': attachMenuVisible, 'send-media-open': tab === 'photo' || tab === 'video', 'photo': tab === 'photo', 'video': tab === 'video', 'send-location-open': tab === 'location', 'disabled-element': userIsInactive}"
            @click.self="showTab()">
          <HandlesList @close-handles-list="closeHandlesList" @choose-handle="chooseHandle" v-if="search_handle" :text="search_handle"></HandlesList>
          <Reply v-if="replyExists"
                 :msg="replyExists"
                 :user="replyExists.user_from === currentUser.id ? currentUser : user"
                 :interlocutorId="user.id"
                 :eventId="eventId"
          ></Reply>
            <div class="inner">
              <div v-if="clipboardImage" class="inner-clipboard">
                <div class="inner-clipboard-close close" @click="clipboardImage = false">

                </div>
                <div class="inner-clipboard-content">
                  <img :src="clipboardImageUrl" @click="showClipBoardImage(clipboardImageUrl)" />
                  <div class="inner-clipboard-content-text">
                    {{trans('copied_from_clipboard')}}
                  </div>
                </div>
              </div>
              <div v-else class="inner-text">
                <div id="attach" class="attach" @click="attachMenuVisible = !attachMenuVisible || showTab()"></div>
                <textarea
                    v-if="isMobile"
                    @paste="pasteFromClipBoard"
                    id="text__field"
                    :rows="textarea.rows"
                    :placeholder="trans('type_something')"
                    v-model="textarea.message"
                    ref="chatMessageTextarea"
                    @focus="focusTextArea"
                    @keyup="searchHandleCheck"
                    @blur="unfocusTextArea"
                    @input="resizeTextArea"
                    @keydown="sendTypingEvent"
                    @keydown.delete="deleteTextMessage"
                    @keyup.enter.exact="resizeTextAreaDebounce"
                    @keydown.enter.shift.exact.prevent
                    @keydown.enter.shift.exact="sendMessage"
                    tabindex="1"
                ></textarea>
                <textarea
                    v-if="!isMobile"
                    @paste="pasteFromClipBoard"
                    id="text__field"
                    :rows="textarea.rows"
                    :placeholder="trans('type_something')"
                    v-model="textarea.message"
                    ref="chatMessageTextarea"
                    @focus="focusTextArea"
                    @blur="unfocusTextArea"
                    @input="resizeTextArea"
                    @keyup="preventInternationalKeyboardBug"
                    @keyup.enter.exact.prevent
                    @keydown.enter.exact.prevent
                    @keydown="sendTypingEvent"
                    @keydown.enter.exact="sendMessage"
                    @keydown.enter.shift.exact="resizeTextAreaDebounce"
                    @keydown.delete="deleteTextMessage"
                    tabindex="1"
                ></textarea>
              </div>
              <div v-if="send_message_preloader" class="spinner-container">
                <img class="preloader"
                     src="/assets/img/preloader.svg"
                     alt="">
              </div>
                <div v-else class="send" @click="sendMessage" tabindex="2">
                    <i class="send"></i>
                </div>
            </div>
            <div class="attach-menu" v-show="attachMenuVisible">
                <div class="attach-menu-inner">
                    <div id="send-photo" class="media-link photo" @click="showTab('photo')">
                        <i class="photo"></i>
                    </div>
                    <div id="send-video" class="media-link video" @click="showTab('video')">
                        <i class="video"></i>
                    </div>
                    <div id="send-location" class="media-link location" @click="showTab('location')">
                        <i class="location"></i>
                    </div>
                </div>
            </div>

            <div class="send-media-box" v-show="tab !== null" :class="{'photo': tab === 'photo', 'video': tab === 'video'}">
                <div class="send-media-wrapper" v-show="tab === 'photo'">
                    <div class="close" @click="showTab()"></div>
                    <vue-custom-scrollbar v-if="isDesktop" class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addPhotoButton" class="pic upload-photo" @click="choosePhoto">
                                <input type="file" id="newPhotoUpload" class="show-for-sr" name="photo" accept="image/*" ref="photo" v-on:change="uploadProfilePhoto($event, true)">
                            </div>
                            <div class="pic" v-for="(photo, index) in photos" @click="selectMedia(photo.id, index, 'photo')"
                                :class="{'selected': photo.active}">
                                <img class="img" :src="photo.photo_small" :src-big="photo.photo_orig" :id="`profile-photo-${photo.id}`" alt="" />
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendPhotos">{{ trans('send') }}</button>
                        </div>
                    </vue-custom-scrollbar>
                    <div v-else class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addPhotoButton" class="pic upload-photo" @click="choosePhoto">
                                <input type="file" id="newPhotoUpload" class="show-for-sr" name="photo" accept="image/*" ref="photo" v-on:change="uploadProfilePhoto($event, true)">
                            </div>
                            <div class="pic" v-for="(photo, index) in photos" @click="selectMedia(photo.id, index, 'photo')"
                                :class="{'selected': photo.active}">
                                <img class="img" :src="photo.photo_small" :src-big="photo.photo_orig" :id="`profile-photo-${photo.id}`" alt="" />
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendPhotos">{{ trans('send') }}</button>
                        </div>
                    </div>
                </div>

                <div class="send-media-wrapper" v-show="tab === 'video'">
                    <div class="close" @click="showTab()"></div>
                    <vue-custom-scrollbar v-if="isDesktop" class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addVideoButton" class="pic upload-photo" @click="chooseVideo">
                                <input type="file" id="newVideoUpload" class="show-for-sr" name="video" accept="video/*" ref="video" v-on:change="uploadVideo($event)">
                            </div>
                            <div class="pic" v-for="(video, index) in videos" @click="selectMedia(video.id, index, 'video')"
                                v-if="!!video.id"
                                :class="{'selected': video.active}">
                                <span class="preloader"
                                    :style="{'background': !video.id ? 'url(/assets/img/preloader.svg) center no-repeat' : 'none'}">
                                </span>
                                <div class="img" v-if="!!video.id" :id="`profile-video-${video.id}`"
                                    :style="{'background': `url(${video.thumb_small}) center / cover`}">
                                </div>
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendVideos">{{ trans('send') }}</button>
                        </div>
                    </vue-custom-scrollbar>
                    <div v-else class="send-media-inner">
                        <div class="pics-catalog">
                            <div id="addVideoButton" class="pic upload-photo" @click="chooseVideo">
                                <input type="file" id="newVideoUpload" class="show-for-sr" name="video" accept="video/*" ref="video" v-on:change="uploadVideo($event)">
                            </div>
                            <div class="pic" v-for="(video, index) in videos" @click="selectMedia(video.id, index, 'video')"
                                v-if="!!video.id"
                                :class="{'selected': video.active}">
                                  <span class="preloader"
                                        :style="{'background': !video.id ? 'url(/assets/img/preloader.svg) center no-repeat' : 'none'}">
                                  </span>
                                <div class="img" v-if="!!video.id" :id="`profile-video-${video.id}`"
                                    :style="{'background': `url(${video.thumb_small}) center / cover`}">
                                </div>
                            </div>
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendVideos">{{ trans('send') }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this,'swipeRight')">
                <div class="send-location-box" id="location__tab" v-show="tab === 'location'">
                    <div class="send-location-inner">
                        <div id="map" class="pick-location no-swiping" v-if="!userLoading">
                            <Map
                                :lat="lat"
                                :lng="lng"
                                :zoom="mapZoom"
                                styles="height: 250px"
                                :clickable="true"
                                :draggable="true"
                                :dragEnd="handleMapMarkerDrag"
                                :zoomChanged="handleZoomChanged"
                                ref="geoMap"
                            />
                        </div>
                        <div class="float-button">
                            <button class="btn" @click="sendLocation">{{ trans('send_location') }}</button>
                        </div>
                    </div>
                </div>
            </vue2-gesture>
        </div>

        <alert :small="true" v-if="deleteAlertVisible" v-on:hide-alert="hideDeleteAlert">
            <p>{{ trans('delete_this_message') }}</p>
            <div class="dialog-actions">
                <button type="button" class="btn darker" @click="hideDeleteAlert">{{ trans('cancel') }}</button>
                <button type="button" class="btn" @click="confirmDelete">{{ trans('delete') }}</button>
            </div>
        </alert>

        <alert v-if="locationPreviewVisible" v-on:hide-alert="hideLocationPreview">
            <Map
                :lat="JSON.parse(locationPreview.message).lat"
                :lng="JSON.parse(locationPreview.message).lng"
                :zoom="JSON.parse(locationPreview.message).zoom"
                :styles="mapStyles"
                :clickable="true"
                :draggable="false"
            />
        </alert>
    </div>
</template>

<style lang="css" scoped>
    @import "../../../_general/lib/slim/slim.min.css";

    .form-error {
        margin-top: 0;
    }
</style>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';
    import InfiniteLoading from 'vue-infinite-loading';

    import {scrollToNewMessages} from '@chat/lib/helpers';
    import chatModule from '@chat/module/store/type'
    import eventsModule from '@events/module/store/type'
    import auth from '@general/lib/auth';
    import Alert from '@buddy/views/widgets/Alert.vue';
    import Map from '@buddy/views/widgets/Map.vue';
    import $ from 'jquery';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import _ from "lodash";
    import UserNotes from "../../../buddy/views/widgets/UserNotes.vue";
    import ContextMenu from "../../../buddy/views/widgets/ContextMenu.vue";
    import EmojiComponent from "../../../buddy/views/widgets/EmojiComponent.vue";
    import Reply from "./Reply.vue";
    import MessageCopiedComponent from "../../../buddy/views/widgets/MessageCopiedComponent.vue";
    import MediaWatcher from "../../../buddy/views/widgets/MediaWatcher.vue";
    import HandlesList from "../../../buddy/views/widgets/HandlesList.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-events').default,
            require('@general/lib/mixin-chat').default,
            require('@general/lib/mixin-clubs').default
        ],
        props: ['chatMode', 'userId', 'eventId', 'conversation_id'],
        components: {
          HandlesList,
          MediaWatcher,
          MessageCopiedComponent,
          Reply,
          EmojiComponent,
          ContextMenu,
          UserNotes,
            Alert,
            InfiniteLoading,
            Map,
            vueCustomScrollbar
        },
        data(){
            return {
                message_started_touch_animation:false,
                send_message_preloader: false,
                message_copied_timeout: false,
                message_copied:  false,
                message_copied_type: false,
                clipboardImage: false,
                touchstarted: false,
                touchstartedX:null,
                touchMoveDistance: false,
                message_clicked_last_time:false,
                selected_message: null,
                isFirstLoad: true,
                refreshQueued: false,
                chatAllowed: false,
                tab: null,
                touchTimer: false,

                selectedPhotos: [],
                selectedVideos: [],

                deleteAlertVisible: false,
                deleteMessageId: 0,

                croppers: [],
                editPhotoId: null,
                slimOptions: this.defaultSlimOptions(),

                textarea: {
                    rows: 1,
                    height: 45,
                    scrollHeight: null,
                    baseScrollHeight: 0,
                    message: ''
                },

                attachMenuVisible: false,

                // TODO: refactor to separate "Location" module
                locationPreview: null,
                locationPreviewVisible: false,
                lat: 52.520389,
                lng: 13.40424,
                mapZoom: 15,
                showScrollBottom: false,
                chat_overflow: 'initial', //needed for fixing scroll issue
                scrollInterval : false,
                search_handle: false
            }
        },
        methods: {
            ...mapActions({
                signalMessagesSeen: 'signalMessagesSeen'
            }),
          chooseHandle(handle){
            if(this.$refs.chatMessageTextarea) {
              let cursorPosition = this.$refs.chatMessageTextarea.selectionStart
              let text = this.textarea.message.substring(0, cursorPosition)
              let arr = text.split("@")
              arr.pop()
              let link_str = arr.join('@') + '@' + handle;
              this.textarea.message = link_str + ' ' + this.textarea.message.substring(cursorPosition)
              this.$nextTick(() => {
                this.$refs.chatMessageTextarea.selectionStart = link_str.length + 1;
                this.$refs.chatMessageTextarea.selectionEnd = link_str.length + 1;
                this.closeHandlesList()
                this.focusMessageField()
              });
            }
          },
          messageClick(e,msg){
            if(msg.failed) {
              this.editMessageForNotDelivered(msg)
            }else{
              if(e.target.classList.contains('issue_link')){
                this.openLink(e);
              }
            }
          },
          pasteFromClipBoard(e){
            let text = '';
            let self = this;
            if (e.clipboardData || e.originalEvent.clipboardData) {
              if((e.originalEvent || e).clipboardData.files){
                const file = (e.originalEvent || e).clipboardData.files[0];
                self.clipboardImage = file;
              }else{
                text = (e.originalEvent || e).clipboardData.getData('text/plain');
              }
            } else if (window.clipboardData) {
              text = window.clipboardData.getData('Text');
            }
          },
          showClipBoardImage(clipboardImageUrl){
            app.$emit('show-clipboard-photo' + (this.chatMode === 'event' ? '-event' : ''), clipboardImageUrl)
          },
          copyCallback(type){
              this.message_copied_type = type;
              this.message_copied = true;
              this.message_copied_timeout = setTimeout(() => {this.message_copied = false},2000)
          },
          scrollToTop(){
            if (this.isMobile) {
              const scrollElement = this.$el.querySelector('#js-chat-user-cmp').firstElementChild;

              this.$nextTick(() => {
                scrollElement.scrollIntoView({block: "center"})
                window.scrollTo(0,document.body.scrollHeight - visualViewport.height);
              });
            } else {
              const containerName = this.chatMode.toLowerCase();
              const scrollDiv = document.getElementById(`conversation-${containerName}-scroll`);
              if(scrollDiv){
                this.$nextTick(() => {
                  scrollDiv.scroll({
                    top: 0,
                  })
                })
              }
            }
          },
          async scrollToMessage(msg){
            const scrollElement = document.getElementById('msg-'+msg.id);
            if (this.isMobile) {
              this.$nextTick(() => {
                scrollElement.scrollIntoView({block: "center"})
                setTimeout(function (){
                  scrollElement.classList.add("scale");
                  setTimeout(function (){
                    scrollElement.classList.remove("scale");
                  },400)
                },200)
              });
            } else {
              const containerName = this.chatMode.toLowerCase();
              const scrollDiv = document.getElementById(`conversation-${containerName}-scroll`);

              if(scrollDiv){
                this.$nextTick(() => {
                  scrollDiv.scroll({
                    top: scrollElement.offsetTop - ($('.conversation-screen').outerHeight()) / 2 + scrollElement.offsetHeight / 2,
                  })
                  setTimeout(function (){
                    scrollElement.classList.add("scale");
                    setTimeout(function (){
                      scrollElement.classList.remove("scale");
                    },400)
                  },200)
                })
              }
            }
          },
          async findAndscrollToMessage(reply_msg_id){
            if(this.selected_message){
              return false;
            }
            console.log('[scrollToMessage] Started',reply_msg_id)
            let self = this;
            let reply_msg = false;
            if(!this.scrollInterval){
              this.scrollInterval = setInterval(function (){
                $.each(self.messages,function(key,val){
                  if(val.id === reply_msg_id){
                    reply_msg = val;
                  }
                })
                if(!reply_msg){
                  self.scrollToTop();
                }else{
                  self.scrollToMessage(reply_msg)
                  clearInterval(self.scrollInterval);
                  self.scrollInterval = false;
                }
              },100);
            }
          },
          replyOn(msg){
            this.$store.commit(chatModule.mutations.replies.add, {
              userId: this.userId,
              eventId: this.eventId,
              chatMode: this.chatMode,
              msg: msg
            })
          },
          deleteEmoji(emoji, message, msg_index){
              let conversation_key = this.chatMode === 'event' ? this.eventId +'-'+ this.userId : this.userId;
              if(emoji.user_id === this.currentUser.id){
                this.$store.dispatch(chatModule.actions.messages.deleteEmoji, {
                  msg : message,
                  msg_index: msg_index,
                  conversation_key: conversation_key
                })
              }
          },
          startTouch(msg,index,e){
              console.log('[startTouch]',e.touches[0].pageX,e.target);
              if(!this.selected_message && e.target.classList.contains('trigger-touch')){
                this.message_started_touch_animation = msg.id;
                this.touchstarted = true;
                this.touchstartedX = e.touches[0].pageX;
                let self = this;
                $('body').css('user-select','none')
                this.touchTimer = setTimeout(function(){
                  self.showContextMenu(msg,index)
                  setTimeout(function (){
                    $('body').css('user-select','auto')
                  },200);
                }, 400);
                if(!navigator.userAgent.match('CriOS')){
                  this.checkDoubleClick(msg,index);
                }
              }
          },
          touchMove(msg,index,e){
            if(!this.selected_message && e.target.classList.contains('trigger-touch')) {
              console.log('[touchMove]', e.touches[0].pageX, e.touches[0].pageX - this.touchstartedX)
              this.message_started_touch_animation = false;
              this.touchMoveDistance = e.touches[0].pageX - this.touchstartedX;
              if(this.touchMoveDistance < -10){
                this.changeScrollBarState(false)
              }
              if (this.touchMoveDistance < 0) {
                $('#msg-' + msg.id).css('left', this.touchMoveDistance + 'px')
              }
              //$('#msg-'+msg.id).css('top',e.touches[0].pageY + 'px')
              if (this.touchTimer) {
                clearTimeout(this.touchTimer);
              }
            }
          },
          endTouch(msg,index,e){
            this.touchstarted = false;
              console.log('[End touch]')
            if(!this.selected_message) {
              this.message_started_touch_animation = false;
              this.changeScrollBarState(true)
              if (this.touchTimer) {
                $('body').css('user-select', 'auto')
                clearTimeout(this.touchTimer);
              }
              if(this.touchMoveDistance < -50){
                this.replyOn(msg);
                this.focusMessageField();
              }
              this.touchMoveDistance = 0;
              $('#msg-'+msg.id).css('left','0')
            }
          },
          hideContextMenu(){
            this.selected_message = false
            this.changeScrollBarState(true)
            this.$refs.emojiModal.hideEmojiModal();
          },
          messageClicked(msg,msg_index,e){
             if(e.target.classList.contains('message-box') ||
                 e.target.classList.contains('timeline') ){
                this.$refs.contextMenu.hideMenu();
             }else{
               if(navigator.userAgent.match('CriOS')){
                 this.checkDoubleClick(msg,msg_index);
               }
             }
          },
          checkDoubleClick(msg,msg_index){
            console.log('[CLICK HANDLE]');
            let now = new Date().getTime();
            let timesince = now - this.message_clicked_last_time;
            console.log('[OUBLETAP CHECK]',timesince)
            if((timesince < 500) && (timesince > 0)){
              //double tap
              let conversation_key = this.chatMode === 'event' ? this.eventId +'-'+ this.userId : this.userId;
              this.$refs.emojiModal.msg_index = msg_index;
              this.$refs.emojiModal.msg = msg;
              this.$refs.emojiModal.conversation_key = conversation_key;
              let self = this;
              let exist_emoji_index =  _.findIndex( this.$store.state.chatModule.chat[msg.channel].messages[conversation_key][msg_index].emojies, function (emoji) {
                return parseInt(emoji.user_id) === self.currentUser.id;
              })
              if(exist_emoji_index === -1){
                this.$refs.emojiModal.addEmoji(1); //green like
              }else{
                this.deleteEmoji(this.$store.state.chatModule.chat[msg.channel].messages[conversation_key][msg_index].emojies[exist_emoji_index],msg,msg_index);
              }
            }
            this.message_clicked_last_time = new Date().getTime();
          },
          showContextMenu(msg,index){
            if(!msg.id){
              let self = this;
              let conversation_key = this.chatMode === 'event' ? this.eventId +'-'+ this.userId : this.userId;
              setTimeout(function (){
                let updated_msg = self.$store.state.chatModule.chat[msg.channel].messages[conversation_key][index]
                self.showContextMenu(updated_msg,index);
              },100)

              return false;
            }
            this.message_started_touch_animation = false;
            this.selected_message = msg.id;
            this.$refs.contextMenu.showMenu(msg,this.$refs.emojiModal,index);

            this.changeScrollBarState(false)
          },
          preventInternationalKeyboardBug(e){
              if(e.code !== 'Enter'){
                //this bug came if choose US international keyboard and set sumbols ˆ,'," at the end of message
                this.$refs.chatMessageTextarea.blur();
                this.$refs.chatMessageTextarea.focus();
                this.searchHandleCheck();
              }
          },

            // ###############################################
            // General methods
            // ###############################################
            selectMedia(id, index, type) {

                let data, arr;

                if (type === 'photo') {
                    data = this.photos[index];
                    arr = this.photos;
                } else {
                    data = this.videos[index];
                    arr = this.videos;
                }

                data.active = !data.active;

                if (!data.active) {
                    this.removeByValue(this.selectedPhotos, data.id)
                } else {
                    type === 'photo' ? this.selectedPhotos.push(data.id) : this.selectedVideos.push(data.id);
                }

                this.$set(arr, index, data);
            },
            removeByValue(arr) {
              let what, a = arguments, length = a.length, ax;
              while (length > 1 && arr.length) {
                what = a[--length];
                while ((ax = arr.indexOf(what)) !== -1) {
                  arr.splice(ax, 1);
                }
              }
              return arr;
            },
            showAttachMenu() {
                this.attachMenuVisible = true;
            },
            hideAttachMenu() {
                if(this.selected_message){
                  return false;
                }
                this.tab = false;
                this.attachMenuVisible = false;
                this.changeScrollBarState(true)
            },
            init(){
                if (!this.chatAllowed){
                    return
                }

                let v = this

                let storageId = this.chatMode === 'user' ?
                    'remember-chat-' + this.userId
                    :
                    'remember-chat-event-' + this.eventId
                if (storageId) {
                    let storedMessage = localStorage.getItem(storageId)
                    if (storedMessage) {
                      this.textarea.message = storedMessage
                    }

                }

                if (this.userHasNewMessages) {
                    let unreadConversations = this.$store.state.chatModule.conversations.all.filter(u => u.unreadMessagesCount)
                  console.log('unread_conversation', unreadConversations);
                    if (
                        unreadConversations.length === 1
                        &&
                        'interlocutor' in unreadConversations[0]
                        &&
                        unreadConversations[0].interlocutor.id === this.user.id
                        &&
                        (this.chatMode === 'event' && 'event' in unreadConversations[0] ? unreadConversations[0].event.id === this.event.id : true)
                    ) {
                        this.signalMessagesSeen()
                    }
                }

                this.initTextAreaValues();
            },
            setChatAllowed(){
                this.chatAllowed = true
                if (this.userId == auth.getUserId()) {
                    //app.log("can't chat with myself");
                    this.chatAllowed = false
                    let v = this

                    setTimeout(function(){
                        if (v.isDesktop) {
                            v.$store.commit(chatModule.mutations.modal, { event: null, user: null, mode: null, minimized: true });
                        } else {
                            if (window.location.pathname !== '/discover'){
                                v.goBack('/discover');
                            }
                        }
                    }, 1500)
                } else {
                    this.chatAllowed = true
                }
            },
            async getMessages(infiniteScroll) {
              this.$nextTick(() => {
                this.chat_overflow = 'hidden'
              })
                console.log('getMessages', {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatMode: this.chatMode
                })

                let dispatchMethod = false
                if (this.chatMode === 'user') {
                    dispatchMethod = chatModule.actions.messages.load;
                } else if (this.chatMode === 'event') {
                    dispatchMethod = chatModule.actions.messages.loadEvent;
                }

                if (dispatchMethod === false){
                    return
                }

                let messages = await this.$store.dispatch(dispatchMethod, {
                    userId: this.userId,
                    eventId: this.eventId,
                    conversationId: this.conversation_id
                })

                if (messages.length) {
                    this.chat_overflow = 'initial'
                    infiniteScroll.loaded()
                }
                if (!this.currentCursor(this.conversation_id)
                || this.currentCursor(this.conversation_id) === 'complete') {
                    this.chat_overflow = 'initial'
                    infiniteScroll.complete()
                }

                this.initTextAreaValues()
                //when chat opened and messages loaded
                this.$nextTick(() => {
                  if (this.isFirstLoad) {
                    this.scrollToBottom()
                    this.isFirstLoad = false;
                  }
                });
            },
            isMessageLast(index) {
                const msg = this.messages[index];
                const nextMsg = this.messages[index+1];

                return !nextMsg || msg.user_from != nextMsg.user_from || msg.idate.substr(0, 16) != nextMsg.idate.substr(0, 16);
            },
            getNewMessagePayload(messageFields){
                let interlocutor = this.user
                let event = this.event
                let isMyEvent = !!(event && event.user_id == auth.getUserId())

                if(this.replyExists){
                  messageFields['reply_message'] = {
                    id: this.replyExists.id,
                    user: {
                      headline: this.replyExists.user_from === this.currentUser.id ? this.currentUser.headline : this.user.headline,
                      handle: this.replyExists.user_from === this.currentUser.id ? this.currentUser.handle : this.user.handle,
                    },
                    message: this.replyExists.message,
                    msg_type: this.replyExists.msg_type,
                    thumbnail_gif: this.replyExists.thumbnail_gif,
                    thumbnail_img: this.replyExists.thumbnail_img,
                    photo_small : this.replyExists.photo_small,
                    lat : this.replyExists.lat,
                    lng : this.replyExists.lng,
                    zoom : this.replyExists.zoom,
                    user_from: this.replyExists.user_from
                  }
                  this.$store.commit(chatModule.mutations.replies.remove, {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatMode:this.chatMode
                  })
                }
                let payload = {
                    userId: this.userId,
                    eventId: this.eventId,
                    conversation: {
                        chatType: this.chatMode,
                        interlocutor: {
                            id: interlocutor.id,
                            handle: interlocutor.handle,
                            isFavorite: interlocutor.isFavorite,
                            isOnline: interlocutor.isOnline,
                            headline: this.chatMode === 'event' && !isMyEvent ? null : interlocutor.headline,
                            photo_small: this.chatMode === 'event' && !isMyEvent ? null: interlocutor.photo_small,
                            wasRecentlyOnline: interlocutor.wasRecentlyOnline
                        },
                        message: {
                            hash: null,
                            id: null,
                            idate: moment().utc(),
                            image_id: null,
                            video_id: null,
                            is_read: "no",
                            cancelled: 0,
                            msg_type: null,
                            user_from: auth.getUserId(),
                            user_to: this.userId,
                            channel: this.chatMode,
                            ...messageFields
                        },
                        unreadMessagesCount: 0
                    },
                    isNewUnreadMessage: false,
                    insertIfMissing: true
                }

                if (this.chatMode === 'event') {
                    payload.conversation.event = {
                        id: event.id,
                        date: event.event_date,
                        isMine: isMyEvent,
                        photo_small: event.photo_small,
                        title: event.title
                    }
                    payload.conversation.message.event_id = event.id
                }

                return payload
            },

            async sendMessage(e) {
                if (e) {
                    e.preventDefault();
                }

                if(this.showJoinModalIfNeed(e)){
                  return false;
                }

                if (this.userIsInactive) {
                    return;
                }

                if(this.clipboardImage){
                  this.send_message_preloader = true;
                  let self = this;
                  app.$on('photo-added-event', function(photo){
                    app.$off('photo-added-event');
                    self.selectedPhotos = [photo.id]
                    self.sendPhotos();
                    self.clipboardImage = false;
                    self.send_message_preloader = false;
                  });
                  this.uploadProfilePhoto({target:{files:[this.clipboardImage]}}, true)
                  return;
                }
                let message = this.textarea.message.replace(/^\s+|\s+$/g, '')
                let msg_with_links = message;
                //change links in text
                //this done so "hard" coz need to handle a lot of edge cases, if you know how to do this easy, please do it
                let regex = {
                  ' ' : ' ',
                  '^' : '',
                  '\n' : '\n'
                };
                $.each(regex,function(reg_key,reg_val){
                  let links_in_text = message.match(new RegExp('('+reg_key+')@[a-zA-Z0-9\-_.]+', "g"));
                  $.each(links_in_text, function (key,link){
                    let re = new RegExp((reg_val === '' ? reg_key : '') + link, "g");
                    link = link.replace(reg_val,'')
                    msg_with_links = msg_with_links.replace(re, reg_val + '<span class="issue_link trigger-touch">'+link+'</span>');
                  });
                })


                if (message) {
                    this.textarea.message = ''

                    let messageHash = 'gen:'+Math.random().toString(36)
                    let conversationUpdatePayload = this.getNewMessagePayload({
                      msg_type: 'text',
                      message,
                      hash: messageHash
                    })

                    this.$store.dispatch(chatModule.actions.conversations.update, {
                        ...conversationUpdatePayload,
                        tracker: 'sendMessage'
                    })


                    this.$store.commit(chatModule.mutations.message.push, {
                        userId: this.userId,
                        eventId: this.eventId,
                        message: {
                            ...conversationUpdatePayload.conversation.message,
                            hash: messageHash,
                            message: msg_with_links
                        }
                    })

                    this.$nextTick(function(){
                        this.scrollToBottom();
                    })

                    try {
                        let response = await axios.post('/api/sendMessage', {
                            userId: this.userId,
                            eventId: this.eventId,
                            msgType: 'text',
                            conversationId: this.conversation_id,
                            channel: this.chatMode,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                                conversationUpdatePayload.conversation.message.reply_message.id : null,
                            message,
                            hash: messageHash
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                  tracker: 'sendMessage response',
                                  userId: this.userId,
                                  eventId: this.eventId,
                                  conversation: data.conversation,
                                  isNewUnreadMessage: false,
                                  insertIfMissing: true
                                })

                                let message = {...data.conversation.message, hash: messageHash }
                                this.$store.commit(chatModule.mutations.message.update, {
                                  userId: this.userId,
                                  eventId: this.eventId,
                                  message
                                })

                                this.$nextTick(function(){
                                  this.scrollToBottom();
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e)
                        this.$store.commit(chatModule.mutations.message.update, {
                          userId: this.userId,
                          eventId: this.eventId,
                          message: {
                            ...conversationUpdatePayload.conversation.message,
                            hash: messageHash,
                            id: messageHash,
                            failed: true,
                          }
                        })

                        this.$nextTick(function(){
                          this.scrollToBottom();
                        })

                    }
                    
                }

                let storageId = this.chatMode === 'user' ?
                    'remember-chat-' + this.userId
                    :
                    'remember-chat-event-' + this.eventId

                if (storageId) {
                    localStorage.setItem(storageId, '')
                }

                this.$nextTick(function(){
                    this.afterSend()
                })
            },
            editMessageForNotDelivered(failedMessage) {
                this.$store.commit(chatModule.mutations.messages.set, {
                    userId: this.userId,
                    eventId: this.eventId,
                    messages: this.messages.filter(message => message.id !== failedMessage.id)
                })

                switch (failedMessage.msg_type) {
                    case 'text':
                        this.textarea.message = failedMessage.message
                        this.$nextTick(function(){
                            this.focusMessageField()
                            if (app.isDesktop) {
                                this.changeScrollStyle(false, true);
                                this.changeScrollStyle(true, false);
                            }
                        })
                        break;
                    case 'image':
                        this.showAttachMenu()
                        this.showTab('photo')
                        let photo = this.photos.find((photo) => photo.id == failedMessage.image_id)
                        photo.active = true
                        this.selectedPhotos = [photo.id]
                        break;
                    case 'video':
                        this.showAttachMenu()
                        this.showTab('video')
                        let video = this.videos.find((video) => video.id == failedMessage.video_id)
                        video.active = true
                        this.selectedVideos = [video.id]
                        break;
                    case 'location':
                        this.showAttachMenu()
                        this.showTab('location')
                        break;
                    default:
                        break;
                }
                
            },

            // ###############################################
            // Ancillary methods
            // ###############################################
            handleGesture(str, e) {
                if (str === 'swipeRight') {
                    // Suppress swipe right, do nothing
                    this.$store.dispatch(chatModule.actions.toggleSwipe, false)
                }
            },
            scrollToBottom() {
                if (this.isMobile) {
                    const scrollElement = this.$el.querySelector('#js-chat-user-cmp').lastElementChild;

                    this.$nextTick(() => {
                        scrollElement.scrollIntoView({block: "center"})
                        window.scrollTo(0,document.body.scrollHeight - visualViewport.height);
                    });
                } else {
                    const containerName = this.chatMode.toLowerCase(); 
                    const scrollDiv = document.getElementById(`conversation-${containerName}-scroll`);

                    const lastMessageElem = this.$el.querySelector('#js-chat-user-cmp').lastElementChild;
                    if(scrollDiv){
                      const coordinates = scrollDiv.scrollHeight - lastMessageElem.offsetHeight;

                      this.$nextTick(() => {
                        scrollDiv.scroll({
                          top: coordinates,
                        })
                      })
                    }
                }
            },
            changeScrollBarState(value) {
                this.$emit('changeScrollBarState', value);
            },
            showTab(tab){
                if(tab !== undefined){
                  if(this.showJoinModalIfNeed()){
                    return false;
                  }
                }
                this.tab = tab
                if (tab === 'location') {
                    this.locationTabClick()
                }

                if (typeof tab === 'undefined') {
                  this.changeScrollBarState(true)
                } else {
                  this.changeScrollBarState(false)
                }
            },
            goToPrevChatPosition(position, iteration = 1) {
                if (iteration++ > 10) {
                    return;
                }

                const hash = document.querySelector('#js-chat-user-cmp');
                if (null === hash) {
                    return
                }

                hash.scrollTop = position;
                setTimeout(() => {
                    this.goToPrevChatPosition(position, iteration);
                }, 50);
            },
            getImagePath(message) {
                let imagePath = message.photo_small;
                let path = null
                if (
                    imagePath.substr(0, 11) === '/assets/img'
                    ||
                    imagePath.substr(0, 4) === 'http'
                ){
                    path = imagePath
                } else {
                    path = `/uploads/users/${imagePath}_orig.jpg`
                }
                return path
            },
            isNewDay(index) {
                const msg = this.messages[index];
                const prevMsg = this.messages[index-1];

                return !prevMsg || msg.idate.substr(0, 10) !== prevMsg.idate.substr(0, 10);
            },

            // ###############################################
            // Photo methods
            // ###############################################
            viewPhoto(msg) { //event
                if(!msg){
                  return false;
                }
                app.prevMessageId = msg.id;
                if (this.isMobile) {
                    if (this.chatMode === 'user') {
                        let userToken = this.user.handle || this.user.id
                        this.goTo(`/chat-photo/${userToken}/${msg.id}/${msg.conversation}`);
                    }
                    else if (this.chatMode === 'event') {
                        let linkInterlocutorId = this.isMyEvent(this.event) ?
                            (this.user.handle || this.user.id)
                            :
                            auth.getUserId();

                        this.goTo(`/chat-event-user-photo/${this.eventId}/${linkInterlocutorId}/${msg.id}/${msg.conversation}`);
                    }
                } else {
                    if (this.chatMode === 'user') {
                        app.$emit('show-view-chat-photo-reveal', this.userId, msg)
                    } else if (this.chatMode === 'event') {
                        app.$emit('show-view-event-chat-photo-reveal', this.eventId, this.userId, msg)
                    } else if (this.chatMode === 'group') {
                        app.$emit('show-view-group-chat-photo-reveal', this.eventId, msg)
                    }
                }
            },
            choosePhoto() {
                this.$refs.photo.click();
            },
            async sendPhotos() {
                this.tab = null;
                if (this.userIsInactive) {
                    return;
                }

                if(this.showJoinModalIfNeed()){
                  return false;
                }
                const photosList = _.pickBy(this.selectedPhotos, value => value); //select photos with value === true
                const photosIds = _.values(photosList);

                if (photosIds.length) {
                    $('.messages-box').click();

                    let messagesHashes            = {},
                        conversationUpdatePayload = this.getNewMessagePayload({msg_type: 'image'})

                    let lastHash = null;
                    photosIds.forEach(function(photoId){
                        let hash  = 'gen:'+Math.random().toString(36),
                            photo = this.photos.find((photo) => photo.id == photoId)

                        this.$store.commit(chatModule.mutations.message.push, {
                            userId: this.userId,
                            eventId: this.eventId,
                            message: _.cloneDeep({
                                ...conversationUpdatePayload.conversation.message,
                                image_id:    parseInt(photoId),
                                photo_small: photo && photo.photo_small,
                                photo_orig:  photo && photo.photo_orig,
                                hash:        hash,
                            })
                        })

                        messagesHashes[photoId] = hash
                        lastHash = hash;
                    }, this)

                  conversationUpdatePayload.conversation.message.hash = lastHash;
                  this.$store.dispatch(chatModule.actions.conversations.update, {
                    ...conversationUpdatePayload,
                    tracker: 'sendPhotos'
                  })

                    this.$nextTick(function(){
                        this.scrollToBottom()
                    })

                    try {
                        let response = await axios.post('/api/sendMessage', {
                            userId:  this.userId,
                            eventId: this.eventId,
                            msgType: 'image',
                            channel: this.chatMode,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                              conversationUpdatePayload.conversation.message.reply_message.id : null,
                            hashes:  messagesHashes,
                            photosIds
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data     = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                    tracker:            'sendPhotos response',
                                    userId:             this.userId,
                                    eventId:            this.eventId,
                                    conversation:       data.conversation,
                                    isNewUnreadMessage: false,
                                    insertIfMissing:    true
                                });

                                if (data.messages.length) {
                                    data.messages.forEach((responseMessage) => {
                                        let message = {
                                            ...responseMessage,
                                            hash: messagesHashes[responseMessage.image_id],
                                        }

                                        this.$store.commit(chatModule.mutations.message.update, {
                                            userId:  this.userId,
                                            eventId: this.eventId,
                                            message
                                        })

                                        this.scrollToBottom()
                                    }, this)
                                }

                                //remove cached chat images from memory
                                this.$store.commit(chatModule.mutations.messages.deleteImages, {
                                    eventId: this.eventId,
                                    userId: this.userId
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e);

                        photosIds.forEach(function(photoId) {
                            let photo = this.photos.find((photo) => photo.id == photoId)

                            this.$store.commit(chatModule.mutations.message.update, {
                                userId: this.userId,
                                eventId: this.eventId,
                                message: _.cloneDeep({
                                    ...conversationUpdatePayload.conversation.message,
                                    image_id:    parseInt(photoId),
                                    photo_small: photo && photo.photo_small,
                                    photo_orig:  photo && photo.photo_orig,
                                    hash:        messagesHashes[photoId],
                                    id:          messagesHashes[photoId],
                                    failed:      true,
                                })
                            })
                        }, this)

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                    
                }

                this.selectedPhotos = []
                const photos = this.photos;

                photos.forEach(function (elem, index) {
                    elem.active ? elem.active = !elem.active : elem.active;

                    this.$set(photos, index, elem);
                }, this);

                this.$nextTick(function(){
                    this.afterSend()
                })
            },

            // ###############################################
            // Video methods
            // ###############################################
            chooseVideo() {
                this.$refs.video.click();
            },
            viewVideo(msg) {
                app.prevMessageId = msg.id;
                if (this.isMobile) {
                    if (this.chatMode === 'user') {
                        let userToken = this.user.handle || this.user.id

                        this.goTo(`/chat-video/${userToken}/${msg.id}/${msg.conversation}`);
                    } else if (this.chatMode === 'event') {
                        let linkInterlocutorId = this.isMyEvent(this.event)
                                ? (this.user.handle || this.user.id)
                                : auth.getUserId();

                        this.goTo(`/chat-event-user-video/${this.eventId}/${linkInterlocutorId}/${msg.id}/${msg.conversation}`);
                    }
                } else {
                    if (this.chatMode === 'user') {
                        app.$emit('show-view-chat-video-reveal', this.userId, msg)
                    } else if (this.chatMode === 'event') {
                        app.$emit('show-view-event-chat-video-reveal', this.eventId, this.userId, msg)
                    } else if (this.chatMode === 'group') {
                        app.$emit('show-view-group-chat-video-reveal', this.eventId, msg)
                    }
                }
            },
            async sendVideos() {
                this.tab = null;
                if (this.userIsInactive) {
                    return;
                }
                if(this.showJoinModalIfNeed()){
                  return false;
                }

                const videosList = _.pickBy(this.selectedVideos, value => value); //select videos with value === true
                const videosIds  = _.values(videosList);

                if (videosIds.length) {
                    $('.messages-box').click();

                    let messagesHashes            = {},
                        conversationUpdatePayload = this.getNewMessagePayload({msg_type: 'video'})
                    let lastHash = null;
                    videosIds.forEach(function(videoId){
                        // We need temporary hash to match and update this message later
                        let hash  = 'gen:'+Math.random().toString(36),
                            video = this.videos.find((video) => video.id == videoId)

                        this.$store.commit(chatModule.mutations.message.push, {
                            userId: this.userId,
                            eventId: this.eventId,
                            message: _.cloneDeep({
                                ...conversationUpdatePayload.conversation.message,
                                video_id:      parseInt(videoId),
                                message:       video && video.video_name,
                                thumbnail_img: (video && video.thumbnail_type === 'img' && video.thumb_small) || null,
                                thumbnail_gif: (video && video.thumbnail_type === 'gif' && video.thumb_small) || null,
                                hash:          hash,
                            })
                        })

                        messagesHashes[videoId] = hash
                        lastHash = hash;
                    }, this)

                  conversationUpdatePayload.conversation.message.hash = lastHash;
                  this.$store.dispatch(chatModule.actions.conversations.update, {
                    ...conversationUpdatePayload,
                    tracker: 'sendVideos'
                  })

                  this.$nextTick(function(){
                        this.scrollToBottom()
                    })

                    try {
                        let response = await axios.post('/api/sendMessage', {
                            userId:  this.userId,
                            eventId: this.eventId,
                            msgType: 'video',
                            channel: this.chatMode,
                            replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                              conversationUpdatePayload.conversation.message.reply_message.id : null,
                            hashes:  messagesHashes,
                            videosIds,
                        })

                        if (response.status === 200) {
                            let index,
                                messages = this.messages,
                                data = response.data

                            index = _.findIndex(messages, (e) => {
                                return e.id === data.conversation.message.id;
                            })

                            if (index === -1) {
                                this.$store.dispatch(chatModule.actions.conversations.update, {
                                    tracker: 'sendVideos response',
                                    userId:             this.userId,
                                    eventId:            this.eventId,
                                    conversation:       data.conversation,
                                    isNewUnreadMessage: false,
                                    insertIfMissing:    true
                                })

                                if (data.messages.length) {
                                    data.messages.forEach((responseMessage) => {
                                        let message = {
                                            ...responseMessage,
                                            hash: messagesHashes[responseMessage.video_id],
                                        }

                                        this.$store.commit(chatModule.mutations.message.update, {
                                            userId:  this.userId,
                                            eventId: this.eventId,
                                            message
                                        })

                                        this.$nextTick(function(){
                                            this.scrollToBottom()
                                        })
                                    }, this)
                                }

                                //remove cached chat videos from memory
                                this.$store.commit(chatModule.mutations.messages.deleteVideos, {
                                    userId:  this.userId,
                                    eventId: this.eventId
                                })
                            }
                        }
                    } catch (e) {
                        if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                          this.showErrorNotification(e.data.error);
                        }
                        console.error('error', e)
                        videosIds.forEach(function(videoId){
                            let video = this.videos.find((video) => video.id == videoId)

                            this.$store.commit(chatModule.mutations.message.update, {
                                userId: this.userId,
                                eventId: this.eventId,
                                message: _.cloneDeep({
                                    ...conversationUpdatePayload.conversation.message,
                                    video_id:      parseInt(videoId),
                                    message:       video && video.video_name,
                                    thumbnail_img: (video && video.thumbnail_type === 'img' && video.thumb_small) || null,
                                    thumbnail_gif: (video && video.thumbnail_type === 'gif' && video.thumb_small) || null,
                                    hash:          messagesHashes[videoId],
                                    id:            messagesHashes[videoId],
                                    failed:        true,
                                })
                            })
                        }, this)

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                }

                this.selectedVideos = [];

                const videos = this.videos;

                videos.forEach(function (elem, index) {
                    elem.active ? elem.active = !elem.active : elem.active;

                    this.$set(videos, index, elem);
                }, this);

                this.$nextTick(function(){
                    this.afterSend();
                })
            },

            // ###############################################
            // Location methods
            // ###############################################
            handleMapMarkerDrag(event) {
                let newLat, newLng;

                if (this.mapProviderIsGmap) {
                    newLat = event.latLng.lat();
                    newLng = event.latLng.lng();
                } else {
                    newLat = event.target.getLatLng().lat;
                    newLng = event.target.getLatLng().lng;
                }

                this.lat = newLat;
                this.lng = newLng;
            },
            handleZoomChanged(event) {
                if (this.mapProviderIsGmap) {
                    this.mapZoom = event;
                } else {
                    this.mapZoom = event.target.getZoom();
                }
            },
            viewLocation(msg) {
                this.locationPreview = msg
                this.locationPreviewVisible = true
            },
            hideLocationPreview() {
                this.locationPreviewVisible = false
                this.locationPreview = null
            },
            locationTabClick() {
                let self = this

                Vue.nextTick(function () {
                    if (self.mapProviderIsGmap) {
                        Vue.$gmapDefaultResizeBus.$emit('resize');
                    } else {
                        self.$refs.geoMap.$refs.osmMap.mapObject.invalidateSize();
                    }
                })

                this.getCurrentPosition()
                    .then(function(pos) {
                        self.lat = pos.lat
                        self.lng = pos.lng

                    });
            },
            async sendLocation() {
                if (this.userIsInactive) {
                    return;
                }

                if(this.showJoinModalIfNeed()){
                  return false;
                }
                this.tab = null;
                let location = {
                    zoom: this.mapZoom,
                    lat:  this.lat,
                    lng:  this.lng,
                };

                // We need temporary hash to match and update this message later
                let messageHash = 'gen:'+Math.random().toString(36)
                let conversationUpdatePayload = this.getNewMessagePayload({
                  msg_type: 'location',
                  message:  JSON.stringify(location),
                  hash: messageHash
                })

                this.$store.dispatch(chatModule.actions.conversations.update, {
                    ...conversationUpdatePayload,
                    tracker: 'sendLocation'
                })


                this.$store.commit(chatModule.mutations.message.push, {
                    userId: this.userId,
                    eventId: this.eventId,
                    message: {
                        ...conversationUpdatePayload.conversation.message,
                        hash: messageHash,
                    }
                })

                this.$nextTick(function(){
                    this.scrollToBottom()
                })

                try {
                    let response = await axios.post('/api/sendMessage', {
                        userId:  this.userId,
                        eventId: this.eventId,
                        msgType: 'location',
                        channel: this.chatMode,
                        replyOn: 'reply_message' in conversationUpdatePayload.conversation.message ?
                          conversationUpdatePayload.conversation.message.reply_message.id : null,
                        message: JSON.stringify(location),
                        hash: messageHash
                    })

                    if (response.status === 200) {
                        let data = response.data

                        this.$store.dispatch(chatModule.actions.conversations.update, {
                            tracker:            'sendLocation response',
                            userId:             this.userId,
                            eventId:            this.eventId,
                            conversation:       data.conversation,
                            isNewUnreadMessage: false,
                            insertIfMissing:    true
                        });

                        let message = {
                            ...data.conversation.message,
                            hash: messageHash
                        }
                        this.$store.commit(chatModule.mutations.message.update, {
                            userId:  this.userId,
                            eventId: this.eventId,
                            message
                        });

                        this.$nextTick(function(){
                            this.scrollToBottom()
                        })
                    }
                } catch (e) {
                    if(e.status === 503 && 'error_type' in e.data && e.data.error_type === 'maintenance_mode'){
                      this.showErrorNotification(e.data.error);
                    }
                    console.error('error', e)
                    this.$store.commit(chatModule.mutations.message.update, {
                        userId:  this.userId,
                        eventId: this.eventId,
                        message: {
                            ...conversationUpdatePayload.conversation.message,
                            hash: messageHash,
                            id: messageHash,
                            failed: true,
                        }
                    })

                    this.$nextTick(function(){
                        this.scrollToBottom()
                    })
                }

                $('.messages-box').click();

                this.$nextTick(function(){
                    this.afterSend();
                })
            },

            // ###############################################
            // Delete methods
            // ###############################################
            tryDelete(messageId) {
                if (this.userIsPro) {
                    this.deleteMessageId = messageId
                    this.showDeleteAlert()
                } else {
                    this.$store.dispatch('requirementsAlertShow', 'deletemsg')
                }
            },
            showDeleteAlert() {
                this.deleteAlertVisible = true
            },
            hideDeleteAlert() {
                this.deleteAlertVisible = false
            },
            confirmDelete() {
                this.$store.dispatch(chatModule.actions.messages.delete, {
                    userId: this.userId,
                    eventId: this.eventId,
                    messageId: this.deleteMessageId
                })
                this.hideDeleteAlert()
            },

            // ###############################################
            // Textarea methods
            // ###############################################
            initTextAreaValues(){
                let messageTmp = this.textarea.message
                this.textarea.message = ''
                if(this.$refs.chatMessageTextarea){
                  this.textarea.baseScrollHeight = this.$refs.chatMessageTextarea.scrollHeight
                }
                this.textarea.message = messageTmp
            },
            resetTextAreaSize(){
                this.textarea.rows   = 1
                this.textarea.height = 45
            },
            focusTextArea(){
                this.attachMenuVisible = false
                this.tab = false;
                this.resizeTextArea()
            },
            unfocusTextArea(){
                if (this.textarea.message == '') {
                    this.resetTextAreaSize()
                }
            },
            resizeTextArea() {
                let rowsCount = Math.ceil((this.$refs.chatMessageTextarea.scrollHeight - 12 * 2) / 21)
                this.textarea.rows = rowsCount + 1 > 6 ? 6 : rowsCount

                if (!this.isMobile) {
                    this.textarea.height = this.textarea.rows * 21 + 12 * 2
                } else {
                    if (rowsCount === 1) this.textarea.height = null
                    else if (rowsCount === 2) this.textarea.height = 59
                    else if (rowsCount === 3) this.textarea.height = 80
                    else if (rowsCount === 4) this.textarea.height = 101
                    else if (rowsCount === 5) this.textarea.height = 122
                    else if (rowsCount >= 6) this.textarea.height = 143
                }

                let storageId = this.chatMode === 'user' ?
                    'remember-chat-' + this.userId
                    :
                    'remember-chat-event-' + this.eventId

                if (storageId) {

                  var message = this.textarea.message
                  if(localStorage.getItem(storageId) && !message) {
                    message = localStorage.getItem(storageId)
                  }
                  localStorage.setItem(storageId, message)
                }

            },

          deleteTextMessage() {
            let storageId = this.chatMode === 'user' ?
                'remember-chat-' + this.userId
                :
                'remember-chat-event-' + this.eventId

            if (storageId) {

            var app = this
              setTimeout(function () {
                var message = app.textarea.message
                localStorage.setItem(storageId, message)
              }, 10)
            }
          },
          closeHandlesList(){
            this.search_handle = false;
            this.changeScrollBarState(true)
          },
          searchHandleCheck(){
            if(this.$refs.chatMessageTextarea) {
              let cursorPosition = this.$refs.chatMessageTextarea.selectionStart
              let lines = this.textarea.message.substring(0,cursorPosition).split("\n")
              let words = lines[lines.length - 1].split(" ")
              if (words[words.length - 1].indexOf('@') === 0 && words[words.length - 1].length > 3) {
                this.changeScrollBarState(false)
                this.search_handle = words[words.length - 1]

                return null;
              }
            }

            this.search_handle = false;
            this.changeScrollBarState(true)
          },
          sendTypingEvent () {
            this.$store.dispatch(chatModule.actions.sendTypeEvent, {
              userId: this.userId,
              eventId: this.eventId
            })
          },
            resizeTextAreaDebounce: _.debounce(function() {
                this.resizeTextArea();
            }, 100),
            afterSend(){
                this.focusMessageField()

                if (app.isDesktop) {
                    this.changeScrollStyle(false, true);
                }

                this.resetTextAreaSize()

                if (app.isDesktop) {
                    this.changeScrollStyle(true, false);
                }

                this.changeScrollBarState(true)
            },
            changeScrollStyle(activeScrollSidebar, disableScroll) {
                this.$emit('changeScrollStyle', activeScrollSidebar, disableScroll);
            },
            focusMessageField(){
              if(this.$refs.chatMessageTextarea && !this.tab){
                this.$refs.chatMessageTextarea.focus();
              }
            },
            reset(){
                this.$store.commit(chatModule.mutations.messages.set, {
                    userId: this.userId,
                    eventId: this.eventId,
                    messages: []
                })

                if (this.$refs.infiniteLoadingChat) {
                    this.$refs.infiniteLoadingChat.stateChanger.reset();
                }
            },
            markConversationAsRead(){
                this.$store.dispatch(chatModule.actions.conversations.markAsRead, {
                    userId: this.userId,
                    eventId: this.eventId,
                    chatType: this.chatMode,
                    sync: true
                })
            },

            // ###############################################
            // Cache methods
            // ###############################################
            softReload(source){
                // if (this.refreshQueued) {
                    this.reset()
                    // this.refreshQueued = false
                // }
            },
            async softLoad() {
                if (this._inactive) {
                    return;
                }
                let conversationId = this.conversation_id;
                if (!conversationId && this.$store.state.chatModule && this.$store.state.chatModule.conversations) {
                    let conversation = this.$store.state.chatModule.conversations.all.find(c => {
                        if (this.chatMode === 'event') {
                            return c.chatType === 'event' && c.interlocutor && c.interlocutor.id === this.userId && c.event && c.event.id === this.eventId;
                        } else if (this.chatMode === 'user') {
                            return c.chatType === 'user' && c.interlocutor && c.interlocutor.id === this.userId;
                        }
                        return false;
                    });
                    if (conversation) {
                        conversationId = conversation.conversation_id || conversation.id;
                    }
                }
                if (!conversationId) {
                    return;
                }
                try {
                    let response = await axios.get(`/api/getConversationMessages/${conversationId}?limit=30`);
                    if (response.status === 200 && response.data && response.data.data) {
                        let messages = _.toArray(response.data.data);
                        let prevCount = this.messages ? this.messages.length : 0;
                        messages.reverse().forEach((msg) => {
                            this.$store.commit(chatModule.mutations.message.push, {
                                userId: this.userId,
                                eventId: this.eventId,
                                message: msg
                            });
                        });
                        this.markConversationAsRead();
                        if (this.messages && this.messages.length > prevCount) {
                            this.$nextTick(() => {
                                this.scrollToBottom();
                            });
                        }
                    }
                } catch (e) {
                    console.error('[ChatComponent] Soft load error', e);
                }
            },
            invalidate(){
                this.refreshQueued = true
                this.page = 0
                this.softReload();
            },

            checkScroll(event) {
                if(!this.selected_message) {
                  if (this.touchTimer) {
                    console.log('[TOUCH CLEAR TIMEOUT]')
                    $('body').css('user-select', 'auto')
                    clearTimeout(this.touchTimer);
                  }
                }
                let eventTarget = event.target;

                if(eventTarget.classList.contains('send-media-inner')
                || eventTarget.classList.contains('handles-list-container')){
                    return false;
                }
                let currentScroll = eventTarget.scrollTop;
                let scrollHeight = eventTarget.scrollHeight;
                let clientHeight = eventTarget.clientHeight;
                this.showScrollBottom = currentScroll + clientHeight <= scrollHeight - 700;
            },
            textAreaFocus() {
                document.getElementById('text__field').focus();
            }
        },
        watch: {
            attachMenuVisible: {
              immediate: true,
              handler: function(newValue, oldValue){
               if(newValue){
                 this.closeHandlesList();
               }
              }
            },
            user: {
                immediate: true,
                handler: function(newValue, oldValue){
                    this.setChatAllowed()
                }
            },
            entitiesLoaded: {
                immediate: true,
                handler: function(newValue, oldValue){
                    if (newValue && newValue !== oldValue) {
                        this.$nextTick(function(){
                            this.init()
                        })
                    }
                }
            },
            refreshQueued: {
                immediate: true,
                handler(value) {
                    console.log('[ChatComponent] Watcher refreshQueued', { value })
                    if (value && !this._inactive) {
                        this.reset()
                        this.refreshQueued = false
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
              userHasNewMessages: 'userHasNewMessages',
              typingEnabled: chatModule.getters.typingEnabled,
              currentCursor: chatModule.getters.conversations.cursor
            }),
            clipboardImageUrl(){
              return window.URL.createObjectURL(this.clipboardImage)
            },
            replyExists(){
              return this.$store.getters[chatModule.getters.replies.get](this.chatMode,this.userId,this.eventId)
            },
            mapStyles() {
              if (app.isDesktop) {
                return "width: 100%;";
              } else {
                return "width: 100%; min-width: 70vw";
              }
            },
            entitiesLoaded(){
                /*console.log('entitiesLoaded', {
                    chatMode: this.chatMode,
                    user: this.user,
                    event: this.event,
                })*/

                if (
                    this.chatMode === 'user'
                    &&
                    !!this.userId
                    &&
                    this.user !== null
                ) {
                    return true

                } else if (
                    this.chatMode === 'event'
                    &&
                    !!this.userId
                    &&
                    !!this.eventId
                    &&
                    this.user !== null
                    &&
                    this.event !== null
                ) {
                    return true
                }

                return false
            },
            user(){
                if (!this.userId || !this.chatMode)
                    return null
                return this.$store.getters.getUser(this.userId)
            },
            event(){
                if (!this.eventId || !this.chatMode)
                    return null
                return this.$store.getters.getEvent(this.eventId)
            },
            ...mapState({
                messages: function(state) {
                    if (this.chatMode === 'user') {
                        return state.chatModule.chat.user.messages[this.userId] || [];
                    } else if (this.chatMode === 'event') {
                        return state.chatModule.chat.event.messages[`${this.eventId}-${this.userId}`] || [];
                    }

                    return []
                },
                currentUser: 'profile',
                photos: 'profilePhotos',
                videos: 'profileVideos',
            }),
            userLoading() {
                let loading = !this.currentUser || !this.currentUser.lng;

                //on user info loaded -> update marker
                if(!loading) {
                    this.lat = parseFloat(this.currentUser.lat);
                    this.lng = parseFloat(this.currentUser.lng);
                }

                return loading;
            },
            userIsInactive() {
                return this?.user?.deleted_at || this?.user?.status === 'suspended'
                    || [100001,100002,100003,100004,100005].includes(this?.user?.id);
            }
        },
        mounted() {
            console.log('[ChatComponent] Mounted', {
                userId: this.userId,
                eventId: this.eventId,
                chatMode: this.chatMode,
            })
            this.$store.commit(chatModule.mutations.conversations.deleteCursor, {
              conversationId: this.conversation_id
            })
            this.$store.commit(chatModule.mutations.messages.set, {
                userId: this.userId,
                eventId: this.eventId,
                messages: []
            })

            let container;

            if (app.isMobile) {
                container = document.getElementById('application-wrapper');
            } else {
                const containerName = this.chatMode.toLowerCase();
                container = document.getElementById(`conversation-${containerName}-scroll`);
            }

            container.addEventListener('scroll', this.checkScroll, true);
            //fixing issue with virtual kyboard above textarea (https://app.asana.com/0/0/1207037155017143/f)
            if(this.isMobile){
              visualViewport.addEventListener("resize", () => {
                this.$nextTick(() => {
                  window.scrollTo(0,document.body.scrollHeight - visualViewport.height);
                });
              });
            }
            this.$refs.infiniteLoadingChat.stateChanger.reset();
            if(!this.userIsInactive){
              this.textAreaFocus();
            }

            if (!this.entitiesLoaded) {
                return
            }

            this.markConversationAsRead()

            app.$on('soft-load-messages', this.softLoad)
            app.$on('invalidate-messages', this.invalidate)
        },
        deactivated() {
            console.log('[ChatComponent] Deactivated')
            if(this.$refs.contextMenu){
              this.$refs.contextMenu.hideMenu();
            }
            this.selected_message = false;
            if(this.scrollInterval){
              clearInterval(this.scrollInterval)
            }
            app.$off('soft-load-messages', this.softLoad)
            app.$off('invalidate-messages', this.invalidate)
        },
        activated() {
            console.log('[ChatComponent] Activated')

            let container;

            this.$nextTick(() => {
                if (app.isMobile) {
                    container = document.getElementById('application-wrapper');
                } else {
                    const containerName = this.chatMode.toLowerCase();
                    container = document.getElementById(`conversation-${containerName}-scroll`);
                }

                container.addEventListener('scroll', this.checkScroll, true);
            })

            if(app.isMobile){
              if(app.prevMessageId !== null){
                const scrollElement = this.$el.querySelector('#msg-'+app.prevMessageId);
                if(scrollElement){
                  this.$nextTick(() => {
                    scrollElement.scrollIntoView({block: "center"})
                  });
                }
              }else{
                this.scrollToBottom();
              }
            }
            this.$refs.infiniteLoadingChat.stateChanger.reset();

            this.textAreaFocus();
            this.markConversationAsRead()

            //this.softReload('Chat')
            app.$off('soft-load-messages', this.softLoad)
            app.$off('invalidate-messages', this.invalidate)
            app.$on('soft-load-messages', this.softLoad)
            app.$on('invalidate-messages', this.invalidate)
        },
        created() {
            if (this.$refs.infiniteLoadingChat) {
              this.$refs.infiniteLoadingChat.stateChanger.reset();
            }

            if (this.userId == auth.getUserId()) {
                //app.log("can't chat with myself");
                return; //return is necessary
            }
        },
        destroyed() {
            this.showTab()
            app.$off('soft-load-messages', this.softLoad)
            app.$off('invalidate-messages', this.invalidate)
            if(this.$refs.contextMenu){
              this.$refs.contextMenu.hideMenu();
            }
            this.selected_message = false;
            if(this.scrollInterval){
              clearInterval(this.scrollInterval)
            }
        }
    }
</script>
